import { useTranslation } from 'react-i18next'

import { NameDto } from '../../../model/NameDto'
import { RebateApprovalPeriod, RebateApprovalType } from '../../../model/RebateGroupsDto'

export interface RebateGroupsOptions {
  rebateApprovalTypes: NameDto[]
  rebatePeriods: NameDto[]
}

export const useRebateGroupsOptions = (): RebateGroupsOptions => {
  const { t } = useTranslation()

  const rebateApprovalTypes = [
    {
      id: RebateApprovalType.Manual,
      name: t('IB.RebatesPage.GroupsPage.Manual'),
    },
    {
      id: RebateApprovalType.Auto,
      name: t('IB.RebatesPage.GroupsPage.Automatic'),
    },
  ]

  const rebatePeriods = [
    {
      id: RebateApprovalPeriod.Weekly,
      name: t('IB.RebatesPage.GroupsPage.Weekly'),
    },
    {
      id: RebateApprovalPeriod.Every2Weeks,
      name: t('IB.RebatesPage.GroupsPage.Every 2 weeks'),
    },
    {
      id: RebateApprovalPeriod.Monthly,
      name: t('IB.RebatesPage.GroupsPage.Monthly'),
    },
  ]

  return { rebateApprovalTypes, rebatePeriods }
}
